import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "../../../../../components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { editStatePolicyType } from "../atoms/atoms";
import { policyTypeData } from "../types/PolicyTypeInterface";

export default function PolicyTypeActionDetails(props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: policyTypeData | undefined;
}) {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStatePolicyType);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.policyTypeName);
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="policyTypeName"
                label="Policy Type Name"
                type="text"
                onChange={(e) => {
                  const value = e.target.value.trim();
                  setInputData(value);
                  if (
                    value === "" ||
                    (value === data?.policyTypeName &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                required={true}
                className={
                  formMethods.formState.errors.policyTypeName &&
                  formMethods.formState.errors.policyTypeName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("policyTypeName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.length === 0 ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.policyTypeName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  className={
                    formMethods.formState.errors.isActive &&
                    formMethods.formState.errors.isActive.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
